// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a98cc87","455":"e70c4f95","977":"b0af257b"}[chunkId] + ".chunk.js";
};